(function () {
  'use strict';

  const CONFIG = {
    productGrid : '.grid.grid--uniform',
    productItem : '[data-product-grid]',
    pagination  : '.pagination',
    nextLink    : '.pagination .next a',
    loadingText : '読み込み中...',
    threshold   : '400px',
    mobileOnly  : false, // PC・スマホ両方有効
    mobileBreak : 768,
  };

  function isMobile() {
    return window.innerWidth < CONFIG.mobileBreak;
  }

  function createLoader() {
    const el = document.createElement('div');
    el.className = 'infinite-loader';
    el.innerHTML = `
      <div class="infinite-loader__bar-wrap">
        <div class="infinite-loader__bar"></div>
      </div>
      <span class="infinite-loader__text">${CONFIG.loadingText}</span>
    `;
    return el;
  }

  function createBackToTop() {
    const btn = document.createElement('button');
    btn.className = 'back-to-top';
    btn.textContent = 'TOPへ戻る';
    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);

    window.addEventListener('scroll', () => {
      if (window.scrollY > 600) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    });
  }

  function fixItem(item) {
    item.querySelectorAll('image-element').forEach(imageEl => {
      const img = imageEl.querySelector('img');
      if (img) {
        img.loading = 'eager';
        img.removeAttribute('data-aos');
        img.style.opacity    = '1';
        img.style.transform  = 'none';
        img.style.visibility = 'visible';
        const div = document.createElement('div');
        div.appendChild(img.cloneNode(true));
        imageEl.parentNode.replaceChild(div, imageEl);
      }
    });

    item.removeAttribute('data-aos');
    item.querySelectorAll('[data-aos]').forEach(el => {
      el.removeAttribute('data-aos');
      el.style.opacity    = '1';
      el.style.transform  = 'none';
      el.style.visibility = 'visible';
    });

    item.style.opacity    = '1';
    item.style.transform  = 'none';
    item.style.visibility = 'visible';
  }

  function initInfiniteScroll() {
    const grid       = document.querySelector(CONFIG.productGrid);
    const pagination = document.querySelector(CONFIG.pagination);
    const nextLink   = document.querySelector(CONFIG.nextLink);

    if (!grid || !nextLink) return;

    if (pagination) pagination.style.display = 'none';

    let nextUrl  = nextLink.href;
    let loading  = false;
    let finished = false;

    const loader = createLoader();
    grid.insertAdjacentElement('afterend', loader);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !loading && !finished) {
          loadNextPage();
        }
      });
    }, { rootMargin: CONFIG.threshold });

    observer.observe(loader);

    async function loadNextPage() {
      loading = true;
      loader.classList.add('is-loading');

      try {
        const res      = await fetch(nextUrl);
        const html     = await res.text();
        const doc      = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(CONFIG.productItem);
        const newNext  = doc.querySelector(CONFIG.nextLink);

        newItems.forEach(item => {
          fixItem(item);
          grid.appendChild(item);
        });

        if (newNext) {
          nextUrl = newNext.href;
        } else {
          finished = true;
          loader.classList.add('is-finished');
          loader.querySelector('.infinite-loader__text').textContent = 'すべての商品を表示しました';
          observer.disconnect();
        }

      } catch (err) {
        console.error('Infinite scroll error:', err);
        loader.querySelector('.infinite-loader__text').textContent = '読み込みに失敗しました';
      }

      loading = false;
      loader.classList.remove('is-loading');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initInfiniteScroll();
    createBackToTop();
  });
  document.addEventListener('page:load', () => {
    initInfiniteScroll();
  });

})();